var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgScheduleIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 0.833496L6.66797 3.3335M13.3346 0.833496V3.3335M14.168 6.66683H5.83464M9.66796 18.3335H10.3346C13.1349 18.3335 14.535 18.3335 15.6046 17.7885C16.5454 17.3092 17.3103 16.5443 17.7897 15.6034C18.3346 14.5339 18.3346 13.1338 18.3346 10.3335V9.66683C18.3346 6.86657 18.3346 5.46644 17.7897 4.39688C17.3103 3.45607 16.5454 2.69116 15.6046 2.2118C14.535 1.66683 13.1349 1.66683 10.3346 1.66683H9.66797C6.86771 1.66683 5.46757 1.66683 4.39802 2.2118C3.45721 2.69116 2.6923 3.45607 2.21294 4.39688C1.66797 5.46644 1.66797 6.86657 1.66797 9.66683V10.3335C1.66797 13.1338 1.66797 14.5339 2.21294 15.6034C2.6923 16.5443 3.45721 17.3092 4.39802 17.7885C5.46757 18.3335 6.8677 18.3335 9.66796 18.3335Z",
    stroke: "#4D6EF5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScheduleIcon);
export default ForwardRef;